import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M8.5 9.057L4.75 5.53c-.276-.26-.724-.26-1 0-.277.26-.277.682 0 .942l4.25 4c.276.26.724.26 1 0l4.25-4c.277-.26.277-.682 0-.942-.276-.26-.724-.26-1 0L8.5 9.057z"
	})
});
export default SvgChevronDown;
